import script from "./Watch.vue?vue&type=script&lang=ts&setup=true"
export * from "./Watch.vue?vue&type=script&lang=ts&setup=true"

import "./Watch.vue?vue&type=style&index=0&id=74e9e3da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e9e3da"]])

export default __exports__